import { render, staticRenderFns } from "./CXScoreCellRenderer.vue?vue&type=template&id=8742387e&scoped=true&"
import script from "./CXScoreCellRenderer.vue?vue&type=script&lang=js&"
export * from "./CXScoreCellRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CXScoreCellRenderer.vue?vue&type=style&index=0&id=8742387e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8742387e",
  null
  
)

export default component.exports